import { FormNames } from 'app/services/autoLockForms/autoLockForms.constants';

export const FORM_NAME = FormNames.ADD_CONDITION;
